import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { FactService } from 'src/app/_services/fact.service';
import { SearchService } from 'src/app/_services/search.service';
import { SubTopicService } from 'src/app/_services/subTopic.service';

@Component({
  selector: 'app-add-fact-to-sub-topic',
  templateUrl: './add-fact-to-sub-topic.component.html',
  styleUrls: ['./add-fact-to-sub-topic.component.css']
})
export class AddFactToSubTopicComponent implements OnInit {
  server_subtopic_id=0
  idList:any=[]
  searchFactForm:FormGroup=undefined
  subTopic=undefined
  factBookList =[]
  currentFactBookList =[]
  loading = true
  isSaving=false
  errorSaving=false
  startFactCount=0
  constructor(private router:Router,private activatedRoute: ActivatedRoute,
    private searchService:SearchService,
    private factService:FactService,
  private subTopicService:SubTopicService) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      xx=>{
        this.server_subtopic_id = xx['server_subtopic_id']
        if(this.server_subtopic_id!=0){
          this.subTopicService.getSubTopicById(this.server_subtopic_id).subscribe(
            {next:(data:ResultData)=>{
              this.subTopic=data.rs.data
              this.factService.getFactsBySubTopic(this.server_subtopic_id).subscribe(
                {
                  next:(data:ResultData)=>{
                    this.currentFactBookList=data.rs.data
                  },error:()=>{}
                }
              )
              this.startFactCount = this.currentFactBookList.length
              this.initSearchForm()
              this.onSearchFormChanges()
            }}

          )
        }

      }
    )

  }


    initSearchForm(){
      this.searchFactForm= new FormGroup({'searchInput': new FormControl('')})

      this.loading=false
     }

     onSearchFormChanges(): void {
      this.searchFactForm.get('searchInput').valueChanges.subscribe(val => {
        if(val.length>2){

          this.searchService.searchFact(val).subscribe(
           {
            next:(data:ResultData)=>{
              this.factBookList=data.rs.data
              this.idList = this.evaluateId(this.factBookList)
            }
           }
          )
      }else{
        this.factBookList=[]
      }
    })
  }

  addFact(server_fact_id:number){
   let item = this.locateFact(server_fact_id)
   let currentIdList = this.evaluateId(this.currentFactBookList)
   if(!currentIdList.includes(item.id)){
     this.currentFactBookList.push(item)
   }

  }


 locateFact(fact_id:number){
   let myS:any=undefined
   for( let i =0; i < this.factBookList.length;i++){
     if(fact_id == this.factBookList[i].id){
       myS=this.factBookList[i]
       break
   }
 }
 return myS
 }

 removeItemFromArray(fact_id:number, fList:Array<any>){
   let index=0
   for( let i =0; i < fList.length;i++){
     if(fact_id == fList[i].id){
       index=i
       fList.splice(index,1)
       break
   }
 }
 }

 evaluateId(myList:any){
   let iid=[]
   for( let i =0; i < myList.length;i++){
     iid.push(myList[i].id)
   }
   return iid
 }

 onConfirm(){
  this.isSaving=true
  let dd=this.formatData()

  this.factService.addFactsToSubTopic(dd).subscribe({
    next:(data:ResultData)=>{
      this.isSaving=false
      if(data.rs['server_subtopic_id']==0){
        this.errorSaving=true
      }else{
        this.router.navigate(['/admin/subtopic/show/',this.server_subtopic_id])
      }
    }
  }

  )

}
formatData(){
  let data = new URLSearchParams();

  data.set('id', this.server_subtopic_id.toString());
  const identifierList = this.evaluateId(this.currentFactBookList)
  for(let i=0; i < identifierList.length;i++){
    data.append('facts', identifierList[i].toString());
  }

  return data.toString()
}
}


